(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('facetMapper', facetMapper);

	function facetMapper(_) {
		function mapFacet(source) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapFacet);

			return {
				name: source.field,
				terms: source.terms,
				none: source.none,
				other: source.other
			};
		}

		return {
			map: mapFacet
		};
	}
	facetMapper.$inject = ['_'];
})();
